module.exports = __webpack_public_path__ + "static/media/16.ac6c4119.jpg";